import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap"; 

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      prescriptionlist:'',
      domainlist:[],
      confirmDelete:null,
    };
    this.deleteConfirm = this.deleteConfirm.bind(this);


    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    

    componentDidMount() {
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var loggedas = localStorage.getItem("loggedas");
      var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: admin_id,
      loggedas: loggedas
      };  

      axios.post(apiUrl+"prescription/list",qs.stringify(postobject)).then(res => {
        if(res.data.status === 'success'){
         
            this.setState({  prescriptionlist: res.data.prescriptionlist, totalRecord: res.data.records_count}, function() {
            
              this.prescriptionlist();
            });
  
        }
      }); 
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");
     var loggedas = localStorage.getItem("loggedas");
     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id,
       loggedas:loggedas
     };
    //  this.props.getprescriptionlist(qs.stringify(postobject))
    axios.post(apiUrl+"prescription/list",qs.stringify(postobject)).then(res => {
      
      if(res.data.status === 'success'){
          this.setState({  prescriptionlist: res.data.prescriptionlist, totalRecord: res.data.records_count}, function() {
            this.prescriptionlist();
          });

      }
    }); 

   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
   var loggedas = localStorage.getItem("loggedas");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id,
    loggedas: loggedas         
  };
  // console.log(postObject);
  // this.props.getprescriptionlist(qs.stringify(postObject));
  axios.post(apiUrl+"prescription/list",qs.stringify(postObject)).then(res => {
    if(res.data.status === 'success'){

        this.setState({  prescriptionlist: res.data.prescriptionlist, totalRecord: res.data.records_count}, function() {
          this.prescriptionlist();
        });

    }else{
      this.setState({  prescriptionlist:'', totalRecord:''}, function() {
        this.prescriptionlist();
      });
    }
  }); 

} 



   componentWillReceiveProps(Props){

     if (Props.deleteprescription!== this.props.deleteprescription) {
      if (Props.deleteprescription[0]["status"] === "success") {
         
          $('.success_message').html('<div class="status_sucess"><h3>'+ Props.deleteprescription[0]["message"]+'</h3></div>');
           var qs = require('qs');
              var admin_id = localStorage.getItem("admin_id");
              var postobject = {
              activePage: 1,
              search_all: '',
              admin_id: admin_id
              };

              // this.props.getprescriptionlist(qs.stringify(postobject));
              axios.post(apiUrl+"prescription/list",qs.stringify(postobject)).then(res => {
                if(res.data.status === 'success'){
           
                    this.setState({  prescriptionlist: res.data.prescriptionlist, totalRecord: res.data.records_count}, function() {
                      this.prescriptionlist();
                    });
          
                }
              }); 
           setTimeout(
          function() {
          $('.success_message').html('');
          //window.location.reload(); 
          }
          .bind(this),
          3000
          );


          this.setState({prescriptionlist: Props.deleteprescription[0]["prescriptionlist"]}, function() {
            this.prescriptionlist();
          });       
          }
          
      }

       if(Props.prescriptionactive !== this.props.prescriptionactive){
      if (Props.prescriptionactive[0]["status"] === "success") {

        $('.success_message').html('<div class="status_sucess"><h3>'+ Props.prescriptionactive[0]["message"]+'</h3></div>');
              var qs = require('qs');
              var admin_id = localStorage.getItem("admin_id");
              var postobject = {
              activePage: 1,
              search_all: '',
              admin_id: admin_id
              };

              // this.props.getprescriptionlist(qs.stringify(postobject));
               axios.post(apiUrl+"prescription/list",qs.stringify(postobject)).then(res => {
    if(res.data.status === 'success'){

        this.setState({  prescriptionlist: res.data.prescriptionlist, totalRecord: res.data.records_count}, function() {
          this.prescriptionlist();
        });

    }
  }); 


           
           setTimeout(
          function() {
          $('.success_message').html('');
          //window.location.reload(); 
          }
          .bind(this),
          3000
          );

      }
    }
     
   }

   deleteConfirm=(confirmstatus,id)=>{
    if(confirmstatus == 'yes'){
          $('.confirm-action-delete').removeClass('show');
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id
        };

      axios.post(apiUrl+"prescription/delete",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){       
              window.location.reload(); 
        }
      }); 
  }else{
    $('.confirm-action-delete').removeClass('show');	
  }
}
deleteprescription(id){
  this.setState({confirmDelete : id})
  $('.confirm-action-delete-message').html('Are you sure delete the prescriptions?');	
  $('.confirm-action-delete').addClass('show');	
 }
activateprescription(id, status){
  let stat = ''
    if(status == 'Inactive'){
      stat = "A";
    }else{
      stat = "I";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
          status: stat
        };

      axios.post(apiUrl+"prescription/change_status",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          window.location.reload(false);
        }
      }); 
}

prescriptionlist() {
    var prescriptionlist = this.state.prescriptionlist;
    if (prescriptionlist != "undefined" && prescriptionlist != null) {
    

      if (prescriptionlist.length > 0) {

        if (Object.keys(prescriptionlist).length > 0) {
          const helperlistDetails = prescriptionlist.map(
            (prescriptionlist, Index) => {
              let sno = Index+1;
              

               if(prescriptionlist.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
            
              return (
                <tr key={prescriptionlist.id}>
      					<td>{sno}</td>
      					<td>{prescriptionlist.medicine_name}</td>
      					<td>${prescriptionlist.price}</td>
      					{/* <td>{prescriptionlist.quantity}</td> */}
      					<td>{prescriptionlist.prescription_detail}</td>
                {/* <td>{status}</td> */}
                <td className="actiongroup" >
                    
                    
                     <Link to={{ pathname: '/prescription-view/'+prescriptionlist.id}} className="" title="View">  <i className="ft-eye" aria-hidden="true"></i></Link>
                    <Link to={{ pathname: '/prescription-edit/'+prescriptionlist.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    {(status == 'Active'?<Link onClick={this.activateprescription.bind(this, prescriptionlist.id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activateprescription.bind(this, prescriptionlist.id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)}      
                     <Link onClick={this.deleteprescription.bind(this,prescriptionlist.id)} className="" title="Duplicate"><i className="ft-trash-2" aria-hidden="true"></i></Link>
                    
                  </td>
                </tr>
              );
            }
          );
          return helperlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="7" className="v-align-nr" style={{textAlign:"center"}}>
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="7" className="v-align-nr" style={{textAlign:"center"}}>
            No Result
          </td>
        </tr>
      );
    }
  }
  


  render() {

    const {domainlist,universitynamelist} = this.state;
	  var current = this;
    var admin_id = localStorage.getItem('admin_id');
   let catImg = '';
  let preview = '';
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="Prescription" /> 
      <div className="content"> 
        <div className="content-wrapper">
        <div class="content-wrapper-before"></div>
   
         <div className="car-listing-wrap leaa-admin-head card">
            <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3> {(this.state.totalRecord>0&&this.state.totalRecord!='')&&this.state.totalRecord}
                  {' '} Prescriptions </h3>
                </div>


               

                 <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                 <div className="add_button">  
                    <a className="" href='/prescription-add'>Add</a>
                </div>
                </div>      
                         
              <div style={{color:"green", fontSize: 30}} className="statusmessage"></div>
            
              <div className="car-listing-row table-avrech">
              <div className="overflow">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
			            <th>Medicine Name</th>
			            <th>Price </th>
			            {/* <th>Quantity</th> */}
			            <th>Prescription Detail</th>
                  {/* <th>Status</th> */}
                  <th style={{width:"100px"}}>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.prescriptionlist()}</tbody>
                </Table>
			        	</div>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      <div className="confirm-action-delete">
        <p className="confirm-action-delete-message"></p>
        <a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.confirmDelete)} className="btn">Yes</a>
        <a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
        <span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
      </div>
    </div>
    );
  }
}
export default (withRouter(List));